import React from 'react'
import { connect } from 'react-redux'
import $ from 'jquery'

import LoadingSpinner from './LoadingSpinner'
import ProgressBar from './ProgressBar'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchReports,
    fetchReportsError,
    export_excel_ranking_reports
} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './RankingReports.css'


var Spinner = require('react-spinkit');

class RankingReportsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hdr: 'Score',
            location: 'Select'
        }

        this.selectPanel = this.selectPanel.bind(this)
        this.filterLocation = this.filterLocation.bind(this)
        this.fetchReportsErrorClear = this.fetchReportsErrorClear.bind(this)
        this.errorNoDataClear = this.errorNoDataClear.bind(this);
        this.rankingReportExport = this.rankingReportExport.bind(this)
    }

    componentDidMount() {
        this.props.dispatch(fetchReports);

        $('li#Score').addClass('selected')
    }

    fetchReportsErrorClear() {
        this.props.dispatch(fetchReportsError);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    selectPanel(e) {
        if (this.props.reports.fetching) return

        this.setState({ hdr: e.target.id })

        $('li.reports').removeClass("selected")
        e.currentTarget.className = "reports selected"
    }

    filterLocation(e) {
        this.setState({
            location: e.target.value
        })
    }
    rankingReportExport(e) {
        if (this.props.reports.fetching) return

        var filter = {};

        filter.Location = this.state.location;
        filter.ReportName = document.getElementsByClassName("reports selected")[0].id;
        export_excel_ranking_reports(this.props.dispatch, filter, this.turn_off_progress_bar());
    }

    turn_off_progress_bar() {
        document.getElementById("progress_bar").display = "none";
    }

    render() {
        return (
            <div className="reports">
                <CommError error={this.props.reports.error} onClose={this.fetchReportsErrorClear} />

                <ConfirmModal open={this.props.reports.noData} heading={"Ranking Reports"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <h1>Ranking Reports{this.props.reports.fetched ? this.props.reports.reports.salaryMonthDisplay : null}</h1>

                <ul>
                    <li className="reports" id="Score" onClick={this.selectPanel}>Overall</li>
                    <li className="reports" id="Gross Margin" onClick={this.selectPanel}>Gross Margin Per Person</li>
                    <li className="reports" id="Percent" onClick={this.selectPanel}>Products & Services</li>
                    <li className="reports" id="TBD" disabled>Survey Results</li>
                </ul>

                <div className="panelFrame">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="col-md-6">
                                <div className="location">
                                    <p>Location:</p>
                                    {
                                        this.props.reports.fetching ?
                                            <select disabled>
                                                <option>Select</option>
                                            </select>
                                        :
                                            <select onChange={this.filterLocation}>
                                                <option>Select</option>
                                                {
                                                    this.props.reports.fetched ?
                                                        this.props.reports.reports.uniqueLocations.map((loc, index) => {
                                                            return <option key={index}>{loc}</option>
                                                            })
                                                    : null
                                                }
                                            </select>
                                    }
                                </div>
                            </div>
                            <div className="col-md-6">
                                <button id="exportReportsBtn" className="btn btn-primary pull-right" onClick={this.rankingReportExport}>Export</button>
                                <span id="startExport">
                                    {
                                        this.props.reports.complete_export === false ?
                                            <LoadingSpinner />
                                        :
                                            null
                                    }
                                </span>
                                <span id="progress_bar"><strong> Export Progress: {this.props.reports.percent_complete}%</strong>
                                    <ProgressBar percentage={this.props.reports.percent_complete} />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            {
                                this.props.reports.fetching ?
                                    <Spinner name='line-spin-fade-loader' />
                                :
                                    null
                            }

                            <div className="col-md-12">
                                <table className="lists table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Team</th>
                                            <th>Location</th>
                                            <th>{this.state.hdr}</th>
                                            <th>Ranking</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.props.reports.fetched ?
                                                this.props.reports.reports.rankingReports.filter((rpt) => {
                                                    if (this.state.location === 'Select')
                                                        return true
                                                    else
                                                        return rpt.location === this.state.location
                                                })
                                                .sort((a, b) => {
                                                    if (this.state.hdr === 'Score') {
                                                        if (a.overallRanking > b.overallRanking)
                                                            return 1
                                                        else if (a.overallRanking < b.overallRanking)
                                                            return -1
                                                        else
                                                            return 0
                                                    }
                                                    else if (this.state.hdr === 'Gross Margin') {
                                                        if (a.gmppRanking > b.gmppRanking)
                                                            return 1
                                                        else if (a.gmppRanking < b.gmppRanking)
                                                            return -1
                                                        else
                                                            return 0
                                                    }
                                                    else if (this.state.hdr === 'Percent') {
                                                        if (a.psRanking > b.psRanking)
                                                            return 1
                                                        else if (a.psRanking < b.psRanking)
                                                            return -1
                                                        else
                                                            return 0
                                                    }
                                                })
                                                .map((rpt, index) => {
                                                    if (this.state.hdr === 'Score')
                                                        return <tr key={index}>
                                                            <td>{rpt.team}</td>
                                                            <td>{rpt.location}</td>
                                                            <td>{rpt.overallScore.toFixed(2)}</td>
                                                            <td>{rpt.overallRanking}</td>
                                                        </tr>
                                                    else if (this.state.hdr === 'Gross Margin') {
                                                        let gmppAmountStr = rpt.gmppAmount.toLocaleString('en')
                                                        let gmppAmountParts = gmppAmountStr.split('.')

                                                        if (gmppAmountParts.length == 1)
                                                            gmppAmountStr += ".00"
                                                        else if (gmppAmountParts[1].length == 1)
                                                            gmppAmountStr += "0"

                                                        return <tr key={index}>
                                                            <td>{rpt.team}</td>
                                                            <td>{rpt.location}</td>
                                                            <td>${gmppAmountStr}</td>
                                                            <td>{rpt.gmppRanking}</td>
                                                        </tr>
                                                    }
                                                    else if (this.state.hdr === 'Percent')
                                                        return <tr key={index}>
                                                            <td>{rpt.team}</td>
                                                            <td>{rpt.location}</td>
                                                            <td>{rpt.psPercent.toFixed(2)}%</td>
                                                            <td>{rpt.psRanking}</td>
                                                        </tr>
                                                })
                                            : null
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="col-md-12">
                                <button id="exportReportsBtn2"  className="btn btn-primary pull-right" onClick={this.rankingReportExport}>Export</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    reports: state.reports
});

export default connect(mapStateToProps)(RankingReportsList)